<template>
    <div id="student-residence-terms">
        <v-card-title class="pb-0">Applications</v-card-title>
        <v-card-text>
            <v-alert v-if="residenceTermsAppliedTo.length == 0" text prominent type="info" icon="mdi-bell">
                No applications have been submitted to date. If you would like to apply for residence, please <v-btn
                    color="#1bc5bd" to="/online-residence-application" small>click here</v-btn>
            </v-alert>
            <v-list v-else>
                <v-list-item v-for="(item,i) in residenceTermsAppliedTo" :key="i">
                    <v-list-item-icon>
                        <v-icon :color="getIconColor(item)">
                            {{ getIcon(item) }}
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.residenceTerm }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.createdDateTime }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-chip dark :color="getStatusColor(item)" small>
                            {{ getStatusLabel(item) }}
                        </v-chip>
                    </v-list-item-icon>
                    <v-list-item-action>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn :color="primaryColor" icon v-bind="attrs" v-on="on"
                                    @click="viewResidenceAgreement(item)">
                                    <v-icon>
                                        mdi-open-in-app
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>View Application</span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'student-residence-terms',
    props: {
        residenceTermsAppliedTo: {
            required: true
        }
    },
    methods: {
        getIcon(item) {
            if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "In-process") {
                return 'mdi-play';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Waiting list") {
                return 'mdi-clock';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Completed") {
                return 'mdi-check';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Withdrawn") {
                return 'mdi-cancel';
            }

            return 'mdi-email-send';
        },
        getIconColor(item) {
            if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "In-process") {
                return '#3699ff';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Waiting list") {
                return '#ffa800';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Completed") {
                return '#1bc5bd';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Withdrawn") {
                return '#5578eb';
            }

            return '#3f4254';
        },
        getStatusColor(item) {
            if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "In-process") {
                return '#3699ff';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Waiting list") {
                return '#ffa800';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Completed") {
                return '#1bc5bd';
            } else if (item.hasOwnProperty('applicationStatus') && item.applicationStatus == "Withdrawn") {
                return '#5578eb';
            }

            return '#3f4254';
        },
        getStatusLabel(item) {
            if (item.hasOwnProperty('applicationStatus') && item.applicationStatus) {
                return item.applicationStatus;
            }

            return 'Applied';
        },
        viewResidenceAgreement(item) {
            this.$router.push({
                path: `/my-applications/${item.id}`
            });
        },
    },
    computed: {
        primaryColor() {
            return '#3699ff';
        }
    }
}
</script>